export default "__VITE_ASSET__B2UQBjF4__"